<template>
  <div class="tag">
    <div class="container">
      <div class="tag__wrapper">
        <div class="tag__top">
          <h2 class="tag__title">{{ t(tagTitle + '.title1') }} <span>{{ t(tagTitle + '.title2') }}</span></h2>
          <router-link :to="translations.i18nRoute({ name: 'tag', params: { tag: tag }})">
            {{ t('buttons.viewAll') }}
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M6.375 3.75L11.625 9L6.375 14.25" stroke="#01AC1B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>
        <swiper
            class="swiper"
            :modules="[Pagination]"
            :pagination="{
                clickable: true
              }"
            :loop="true"
            :speed="500"
            :spaceBetween="20"
            :breakpoints="{
              100: {
                slidesPerView: 1
              },
              400: {
                slidesPerView: 2
              },
              700: {
                slidesPerView: 3
              },
              1000: {
                slidesPerView: 4
              },
              1300: {
                slidesPerView: 5
              }
            }"
        >
          <swiper-slide
              class="swiper__slide"
              v-for="product in products"
              :key="product.node.uuid"
          >
            <router-link :to="translations.i18nRoute({ name: 'product', params: { productSlug: product.node.slug } })">
              <img :src="product.node.images.edges[0]?.node.image" :alt="product.node.name" >
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/pagination';
import 'swiper/css';
import {Pagination} from "swiper/modules";
import {Products} from "@/core/api/products.js";
import {onMounted, ref} from "vue";
import translations from "@/core/helpers/translations.js";

const props = defineProps({
  tag: String,
  tagTitle: String
})

const {t} = useI18n()

const products = ref([])

const getProducts = async () => {
  const res = await Products.getProducts(`tags: "${props.tag}", first: 12`)
  products.value = res.data.products.edges
}

onMounted( async () => {
  await getProducts()
})
</script>

<style lang="scss" scoped>
.tag {
  padding-top: 50px;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & a {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 10px;
      background-color: transparent;
      transition: 0.2s;

      color: #222;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;

      & svg {
        transition: 0.2s;
      }

      @include hover {
        & svg {
          transform: rotate(1turn);
        }
      }
    }
  }

  &__title {
    padding-bottom: 10px;
    color: #666;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;

    & span {
      color: #01AC1B;
    }
  }
}

.swiper {
  padding-block: 40px;

  &__slide {
    & img {
      width: 100%;
      object-fit: cover;
      border-radius: 16px;
    }
  }
}

@media (max-width: 500px) {
  .tag {
    &__title {
      padding-bottom: 5px;
      font-size: 20px;
    }
  }
}
</style>